const classroomSchedule = {
  namespaced: true,
  state: {
    thisMonthList: {
      data: [],
      meta: {},
    },
    thisMonthListLoading: false,
    incompletedList: {
      data: [],
      meta: {},
    },
    incompletedListLoading: false,
  },
  getters: {
    thisMonthList: (state) => {
      return state.thisMonthList
    },
    isThisMonthListLoading: (state) => {
      return state.thisMonthListLoading
    },
    incompletedList: (state) => {
      return state.incompletedList
    },
    isIncompletedListLoading: (state) => {
      return state.incompletedListLoading
    },
  },
  mutations: {
    setThisMonthList(state, data) {
      state.thisMonthList = data
    },
    setThisMonthListLoading(state, data) {
      state.thisMonthListLoading = data
    },
    setIncompletedList(state, data) {
      state.incompletedList = data
    },
    setIncompletedListLoading(state, data) {
      state.incompletedListLoading = data
    },
  },
  actions: {
    async getThisMonthList({ commit, dispatch }, filters) {
      commit('setThisMonthListLoading', true)
      try {
        const response = await axios.get(
          `/api/dashboard/classroom-schedules/this-month`,
          {
            params: filters,
            paramsSerializer: (params) => {
              return qs.stringify(params, {
                arrayFormat: 'indices',
                allowDots: true,
                skipNulls: true,
              })
            },
          }
        )
        commit('setThisMonthList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'dashboard/classroomSchedule/getThisMonthList', error },
          { root: true }
        )
      } finally {
        commit('setThisMonthListLoading', false)
      }
    },
    async getIncompletedList({ commit, dispatch }, filters) {
      commit('setIncompletedListLoading', true)
      try {
        const response = await axios.get(
          `/api/dashboard/classroom-schedules/incompleted`,
          {
            params: filters,
            paramsSerializer: (params) => {
              return qs.stringify(params, {
                arrayFormat: 'indices',
                allowDots: true,
                skipNulls: true,
              })
            },
          }
        )
        commit('setIncompletedList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'dashboard/classroomSchedule/getIncompletedList', error },
          { root: true }
        )
      } finally {
        commit('setIncompletedListLoading', false)
      }
    },
  },
}

const classroom = {
  namespaced: true,
  state: {
    endingSoonList: {
      data: [],
      meta: {},
    },
    endingSoonListLoading: false,
    startingSoonList: {
      data: [],
      meta: {},
    },
    startingSoonListLoading: false,
  },
  getters: {
    endingSoonList: (state) => {
      return state.endingSoonList
    },
    isEndingSoonListLoading: (state) => {
      return state.endingsoonListLoading
    },
    startingSoonList: (state) => {
      return state.startingSoonList
    },
    isStartingSoonListLoading: (state) => {
      return state.startingSoonListLoading
    },
  },
  mutations: {
    setEndingSoonList(state, data) {
      state.endingSoonList = data
    },
    setEndingSoonListLoading(state, data) {
      state.endingSoonListLoading = data
    },
    setStartingSoonList(state, data) {
      state.startingSoonList = data
    },
    setStartingSoonListLoading(state, data) {
      state.startingSoonListLoading = data
    },
  },
  actions: {
    async getEndingSoonList({ commit, dispatch }, filters) {
      commit('setEndingSoonListLoading', true)
      try {
        const response = await axios.get(
          `/api/dashboard/classrooms/ending-soon`,
          {
            params: filters,
            paramsSerializer: (params) => {
              return qs.stringify(params, {
                arrayFormat: 'indices',
                allowDots: true,
                skipNulls: true,
              })
            },
          }
        )
        commit('setEndingSoonList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'dashboard/classroom/getEndingSoonList', error },
          { root: true }
        )
      } finally {
        commit('setEndingSoonListLoading', false)
      }
    },
    async getStartingSoonList({ commit, dispatch }, filters) {
      commit('setStartingSoonListLoading', true)
      try {
        const response = await axios.get(
          `/api/dashboard/classrooms/starting-soon`,
          {
            params: filters,
            paramsSerializer: (params) => {
              return qs.stringify(params, {
                arrayFormat: 'indices',
                allowDots: true,
                skipNulls: true,
              })
            },
          }
        )
        commit('setStartingSoonList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'dashboard/classroom/getStartingSoonList', error },
          { root: true }
        )
      } finally {
        commit('setStartingSoonListLoading', false)
      }
    },
  },
}

const invoice = {
  namespaced: true,
  state: {
    outstandingList: {
      data: [],
      meta: {},
    },
    outstandingListLoading: false,
  },
  getters: {
    outstandingList: (state) => {
      return state.outstandingList
    },
    isOutstandingListLoading: (state) => {
      return state.outstandingListLoading
    },
  },
  mutations: {
    setOutstandingList(state, data) {
      state.outstandingList = data
    },
    setOutstandingListLoading(state, data) {
      state.outstandingListLoading = data
    },
  },
  actions: {
    async getOutstandingList({ commit, dispatch }, filters) {
      commit('setOutstandingListLoading', true)
      try {
        const response = await axios.get(
          `/api/dashboard/invoices/outstanding`,
          {
            params: filters,
            paramsSerializer: (params) => {
              return qs.stringify(params, {
                arrayFormat: 'indices',
                allowDots: true,
                skipNulls: true,
              })
            },
          }
        )
        commit('setOutstandingList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'dashboard/invoice/getOutstandingList', error },
          { root: true }
        )
      } finally {
        commit('setOutstandingListLoading', false)
      }
    },
  },
}

export const student = {
  namespaced: true,
  state: {
    followUpList: [],
    followUpListLoading: false,
  },
  getters: {
    followUpList: (state) => {
      return state.followUpList
    },
    isFollowUpListLoading: (state) => {
      return state.followUpListLoading
    },
  },
  mutations: {
    setFollowUpList(state, data) {
      state.followUpList = data
    },
    setFollowUpListLoading(state, data) {
      state.followUpListLoading = data
    },
  },
  actions: {
    async getFollowUpList({ commit, dispatch }, filters) {
      commit('setFollowUpListLoading', true)
      try {
        const response = await axios.get(`/api/dashboard/students/follow-up`, {
          params: filters,
          paramsSerializer: (params) => {
            return qs.stringify(params, {
              arrayFormat: 'indices',
              allowDots: true,
              skipNulls: true,
            })
          },
        })
        commit('setFollowUpList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'dashboard/student/getFollowUpList', error },
          { root: true }
        )
      } finally {
        commit('setFollowUpListLoading', false)
      }
    },
  },
}

export const dashboard = {
  namespaced: true,
  modules: {
    classroomSchedule,
    classroom,
    invoice,
    student,
  },
}
